import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LegalPage, LegalVersionPage } from "../../Pages/Legal/LegalPage";
import { AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";

// Auth Check
import AuthRoutes from "./AuthRoutes";
// Auth Check

// Authentication
import LoginForm from "../../Pages/Authentication/LoginForm";
import Welcome from "../../Pages/Authentication/Components/Welcome/Welcome";
import GetCode from "../../Pages/ResetPassword/GetCode";
import ResetPassword from "../../Pages/ResetPassword/ResetPassword";
import Authorize from "../../Pages/OAuth/Authorize";
// Authentication

// Roles Auth
import ShipperRoutes from "./ShipperRoutes";
import CarrierRoutes from "./CarrierRoutes";
import AdminRoutes from "./AdminRoutes";
import WarehouseRoutes from "./WarehouseRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";
// Roles Auth

// Shipper Routes
import Ship from "../../Pages/Shipper/Customer/MainPages/ShipPage/Ship";
import Shipments from "../../Pages/Shipper/Customer/MainPages/Shipments/Shipments";
import OneTimeShipperShipments from "../../Pages/Shipper/Customer/MainPages/Shipments/OneTimeShipperShipments";
import Packages from "../../Pages/Shipper/Customer/MainPages/Packages/Packages";
import Carriers from "../../Pages/Shipper/Customer/MainPages/Carriers/Carriers";
import Orders from "../../Pages/Shipper/Customer/MainPages/Orders/Orders";
import Scans from "../../Pages/Shipper/Customer/MainPages/Scans/Scans";
import Payments from "../../Pages/Shipper/Customer/MainPages/Payments/Payments";
import Tickets from "../../Pages/Shipper/Customer/MainPages/Tickets/Tickets";
import ProductsShipper from "../../Pages/Shipper/Customer/MainPages/Products/Products";
import ProductNotAvailable from "../../Pages/Shipper/Customer/MainPages/Products/ProductNotAvailable";

import HelperUserSettings from "../../Pages/Shipper/Customer/MainPages/Settings/HelperUserSettings";
import RolesSettings from "../../Pages/Shipper/Customer/MainPages/Settings/RolesSettings";
import Referrals from "../../Pages/Shipper/Customer/MainPages/Settings/Referrals";
import PermissionsSettings from "../../Pages/Shipper/Customer/MainPages/Settings/PermissionsSettings";
import Profile from "../../Pages/Shipper/Customer/NavDropdown/Profile";
import Privacypolicy from "../../Pages/Shipper/Customer/NavDropdown/Privacypolicy";
import Termsandconditions from "../../Pages/Shipper/Customer/NavDropdown/Termsandconditions";
import WareHouseSettings from "../../Pages/Shipper/Customer/MainPages/Settings/WareHouseSettings";
import Plugins from "../../Pages/Shipper/Customer/MainPages/Plugins/Plugins";
import AddNewOrderPage from "../../Pages/Shipper/Customer/MainPages/AddNewProduct/AddNewProductPage";
// Shipper Routes

// Admin Routes
import UserRegistration from "../../Pages/Admin/UserRegistration/UserRegistration";
import NewsLetter from "../../Pages/Admin/NewsLetter/NewsLetter";
import Companies from "../../Pages/Admin/Companies/Companies";
import AdminPayments from "../../Pages/Admin/Payments/Payments";
import AdminShipments from "../../Pages/Admin/AdminShipments/AdminShipments";
import AdminTickets from "../../Pages/Admin/Tickets/Tickets";
import AdminQuotes from "../../Pages/Admin/Quotes/Quotes";

// Admin Routes

// Warehouse Routes
import Clients from "../../Pages/Warehouse/Clients/Clients";
import WarehouseOrders from "../../Pages/Warehouse/WarehouseOrders/Orders";
import AddWarehouseProduct from "../../Pages/Products/AddProduct/AddWarehouseProduct";
// import WarehouseShipment from "../../Pages/Warehouse/WarehouseShipment/Shipments";
import WarehouseDashboard from "../../Pages/Warehouse/Dashboard/WarehouseDashboard";
import WarehouseProducts from "../../Pages/Warehouse/Products/Products";
// Warehouse Routes

// Carrier Routes
import Carriership from "../../Pages/Carrier/Carriership";
import Dispatcher from "../../Pages/Carrier/Dispatcher/Dispatcher";
import Drivers from "../../Pages/Carrier/Drivers/Drivers";
import Vehicle from "../../Pages/Carrier/Vehicles/Vehicles";
import CreateZone from "../../Pages/Carrier/CreateZone/CreateZone";
// Carrier Routes

// Testing Routes
// Testing Routes

// Products Routes

import AddTransferNote from "../../Pages/Products/AddTransferNotes/Components/CreateTransferNote";
import Sales from "../../Pages/Sales/Sales";
import Marketplaces from "../../Pages/Shipper/Customer/MainPages/MarketPlaces/MarketPlaces";
import AdminLoginForm from "../../Pages/Authentication/AdminLoginForm";
import StockReceivedForm from "../../Pages/StockReceived/StockReceivedForm";
import StorageLocations from "../../Pages/Warehouse/StorageLocations/StorageLocations";
import TableSettings from "../../Pages/Shipper/Customer/MainPages/Settings/SystemsSettings/TableSettings";
import CarrierFinances from "../../Pages/Carrier/Finances/Finances";
import TimeSettings from "../../Pages/Shipper/Customer/MainPages/Settings/SystemsSettings/TimeSettings";
import AppearanceSettings from "../../Pages/Shipper/Customer/MainPages/Settings/SystemsSettings/AppearanceSettings";
import UnitSettings from "../../Pages/Shipper/Customer/MainPages/Settings/SystemsSettings/UnitSettings";
import EmailConfigSettings from "../../Pages/Shipper/Customer/MainPages/Settings/SystemsSettings/EmailConfigSettings";
import DeliveryEmailSettings from "../../Pages/Shipper/Customer/MainPages/Settings/SystemsSettings/DeliveryEmailSettings";
import AutoArchiveSettings from "../../Pages/Shipper/Customer/MainPages/Settings/SystemsSettings/AutoArchiveSettings";
import AuthRoles from "../../Pages/Authentication/AuthRoles";
import CarrierForm from "../Auth/Forms/CarrierForm";
import ShipperForm from "../Auth/Forms/ShipperForm";
import WarehouseForm from "../Auth/Forms/WarehouseForm";
import ProductForm from "../../Pages/Products/AddProduct/ProductForm";
import Unauthorized from "../../Pages/Unauthorized/Unauthorized";

// Products Routes

function Animatedroutes() {
  const location = useLocation();
  const user = useSelector((state) => state.user);
  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route element={<AuthRoutes />}>
          {/* Shipper Routes */}
          <Route
            element={
              <ShipperRoutes
                mergedPermissions={user?.mergedPermissions}
                parentId={user?.parent_id}
              />
            }
          >
            <Route path="/" element={<Ship />} />
            <Route
              path="/shipments"
              element={
                user?.role === "oneTimeShipper" ? (
                  <OneTimeShipperShipments />
                ) : (
                  <Shipments />
                )
              }
            />
            <Route
              path="/products"
              element={
                user?.user_approved_warehouses?.length > 0 ? (
                  <ProductsShipper />
                ) : (
                  <ProductNotAvailable />
                )
              }
            />
            <Route
              path="/stock-received-form"
              element={<StockReceivedForm />}
            />

            <Route path="/Packages" element={<Packages />} />
            <Route path="/Marketplaces" element={<Marketplaces />} />
            <Route path="/Carriers" element={<Carriers />} />
            <Route path="/Orders" element={<Orders />} />
            <Route path="/orders/scans" element={<Scans />} />
            <Route path="/Payments" element={<Payments />} />
            <Route path="/Tickets" element={<Tickets />} />
            <Route
              path="/settings/manage-helper-users"
              element={<HelperUserSettings />}
            />
            <Route path="/settings/manage-roles" element={<RolesSettings />} />
            <Route path="/settings/referrals" element={<Referrals />} />
            <Route
              path="/settings/manage-permissions"
              element={<PermissionsSettings />}
            />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/Privacypolicy" element={<Privacypolicy />} />
            <Route
              path="/Termsandconditions"
              element={<Termsandconditions />}
            />
            <Route
              path="/settings/manage-warehouse"
              element={<WareHouseSettings />}
            />
            <Route
              path="/settings/table-pagination"
              element={<TableSettings />}
            />
            <Route path="/settings/time-zone" element={<TimeSettings />} />
            <Route
              path="/settings/delivery-emails"
              element={<DeliveryEmailSettings />}
            />
            <Route
              path="/settings/auto-archive"
              element={<AutoArchiveSettings />}
            />
            <Route path="/settings/units" element={<UnitSettings active="3_2" />} />
            <Route
              path="/settings/appearance"
              element={<AppearanceSettings />}
            />
            <Route path="/plugins/:plugin" element={<Plugins />} />
            <Route path="/AddNewOrderPage" element={<AddNewOrderPage />} />
            <Route path="/AddProduct" element={<ProductForm />} />
            <Route path="/edit-product" element={<ProductForm />} />
            <Route path="/AddTransferNote" element={<AddTransferNote />} />
            <Route path="/sales" element={<Sales />} />
          </Route>
          {/* Shipper Routes */}

          {/* Warehouse Routes */}
          <Route
            element={
              <WarehouseRoutes
                mergedPermissions={user?.mergedPermissions}
                parentId={user?.parent_id}
              />
            }
          >
            <Route path="/warehouse-user-profile" element={<Profile />} />
            <Route
              path="/warehouse-dashboard"
              element={<WarehouseDashboard />}
            />
            <Route path="/warehouse-clients" element={<Clients />} />
            <Route path="/warehouse-orders" element={<WarehouseOrders />} />
            <Route path="/warehouse-payments" element={<Payments />} />
            <Route path="/warehouse-ship" element={<Ship />} />
            {/* <Route path="/warehouse-shipment" element={<WarehouseShipment />} /> */}
            <Route
              path="warehouse/settings/manage-helper-users"
              element={<HelperUserSettings />}
            />
            <Route
              path="warehouse/settings/manage-roles"
              element={<RolesSettings />}
            />
            <Route
              path="warehouse/settings/manage-permissions"
              element={<PermissionsSettings />}
            />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/Privacypolicy" element={<Privacypolicy />} />
            <Route
              path="/Termsandconditions"
              element={<Termsandconditions />}
            />
            <Route
              path="warehouse/settings/manage-warehouse"
              element={<WareHouseSettings />}
            />
            <Route
              path="warehouse/settings/table-pagination"
              element={<TableSettings />}
            />
            <Route
              path="warehouse/settings/time-zone"
              element={<TimeSettings />}
            />
            <Route
              path="warehouse/settings/units"
              element={<UnitSettings active="3_3" />}
            />
            <Route
              path="warehouse/settings/email-config"
              element={<EmailConfigSettings />}
            />
            <Route
              path="warehouse/settings/appearance"
              element={<AppearanceSettings />}
            />
            <Route path="/warehouse-products" element={<WarehouseProducts />} />
            <Route
              path="/warehouse-stock-received-form"
              element={<StockReceivedForm />}
            />
            <Route
              path="/warehouse-AddProduct"
              element={<AddWarehouseProduct />}
            />
            <Route path="/storage-locations" element={<StorageLocations />} />
            <Route
              path="/settings/manage-warehouse"
              element={<WareHouseSettings />}
            />
          </Route>
          {/* Warehouse Routes End*/}

          {/* Carrier Routes */}
          <Route element={<CarrierRoutes />}>
            <Route path="/Carriership" element={<Carriership />} />
            <Route path="/dispatcher" element={<Dispatcher />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/vehicles" element={<Vehicle />} />
            <Route path="/carrier-profile" element={<Profile />} />
            <Route path="/create-zone" element={<CreateZone />} />
            <Route path="/carrier-payments" element={<CarrierFinances />} />
            <Route
              path="carrier/settings/manage-helper-users"
              element={<HelperUserSettings />}
            />
            <Route
              path="carrier/settings/manage-roles"
              element={<RolesSettings />}
            />
            <Route
              path="carrier/settings/manage-permissions"
              element={<PermissionsSettings />}
            />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/Privacypolicy" element={<Privacypolicy />} />
            <Route
              path="/Termsandconditions"
              element={<Termsandconditions />}
            />
            <Route
              path="carrier/settings/manage-warehouse"
              element={<WareHouseSettings />}
            />
            <Route
              path="carrier/settings/table-pagination"
              element={<TableSettings />}
            />
            <Route
              path="carrier/settings/appearance"
              element={<AppearanceSettings />}
            />
          </Route>
          {/* Carrier Routes End*/}

          {/* Admin Routes */}
          <Route element={<AdminRoutes />}>
            <Route path="/Users" element={<UserRegistration />} />
            <Route path="/user/Newsletter" element={<NewsLetter />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/payments-admin" element={<AdminPayments />} />
            <Route path="/shipments-admin" element={<AdminShipments />} />
            <Route path="/tickets-admin" element={<AdminTickets />} />
            <Route path="/quotes-admin" element={<AdminQuotes />} />

            <Route
              path="admin/settings/manage-helper-users"
              element={<HelperUserSettings />}
            />
            <Route
              path="admin/settings/manage-roles"
              element={<RolesSettings />}
            />
            <Route
              path="admin/settings/manage-permissions"
              element={<PermissionsSettings />}
            />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/Privacypolicy" element={<Privacypolicy />} />
            <Route
              path="/Termsandconditions"
              element={<Termsandconditions />}
            />
            <Route
              path="admin/settings/manage-warehouse"
              element={<WareHouseSettings />}
            />
            <Route
              path="admin/settings/table-pagination"
              element={<TableSettings />}
            />
            <Route path="admin/settings/time-zone" element={<TimeSettings />} />
            <Route
              path="admin/settings/units"
              element={<UnitSettings active="3_2" />}
            />
            <Route
              path="admin/settings/appearance"
              element={<AppearanceSettings />}
            />
          </Route>

          <Route path="/unauthorized" element={<Unauthorized />} />
        </Route>
        {/* Admin Routes */}

        {/* OAuth 2.0 authorization endpoint (Claude MCP).
            MUST stay outside BOTH guards:
              - AuthRoutes renders <Navigate to="/Login"/> for logged-out users
                with no search/state preservation, which would irrecoverably
                drop client_id, state and code_challenge.
              - AuthenticationRoutes redirects logged-IN shippers to "/", so the
                consent screen could never render for its primary user.
            The page does its own session and role gating. */}
        <Route path="/authorize" element={<Authorize />} />

        {/* Legal pages (Terms of Service, Privacy Policy): public, outside both
            guards so they open logged in or out, from the sign-up form too. */}
        <Route path="/conditions" element={<LegalPage type="terms" language="fr" />} />
        <Route path="/terms" element={<LegalPage type="terms" language="en" />} />
        <Route path="/confidentialite" element={<LegalPage type="privacy" language="fr" />} />
        <Route path="/privacy" element={<LegalPage type="privacy" language="en" />} />
        <Route path="/policy" element={<Navigate to="/privacy" replace />} />
        <Route path="/terms/archive/2026-10-30" element={<LegalPage type="terms" language="en" version="archive-2026-10-30" />} />
        <Route path="/policy/archive/2026-10-30" element={<LegalPage type="privacy" language="en" version="archive-2026-10-30" />} />
        <Route path="/legal/:type/:language/:version" element={<LegalVersionPage />} />

        {/* Authentication Routes */}
        <Route element={<AuthenticationRoutes />}>
          <Route path="/Register" element={<AuthRoles />} />
          <Route path="/register/carrier" element={<CarrierForm />} />
          <Route path="/register/shipper" element={<ShipperForm />} />
          <Route path="/register/warehouse" element={<WarehouseForm />} />
          <Route path="/login" element={<AuthRoles />} />
          <Route path="/login/:role" element={<LoginForm />} />
          <Route path="/admin-login" element={<AdminLoginForm />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/get-code" element={<GetCode />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        {/* Authentication Routes */}

        {/* Testing Routes */}
        {/* Testing Routes */}
      </Routes>
    </AnimatePresence>
  );
}

export default Animatedroutes;
